import React from "react";
import "./footer.css";
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import EmailIcon from "@mui/icons-material/Email";
import PlaceIcon from '@mui/icons-material/Place';

const Footer = () => {
  return (
    <div className="footer">
      <div className="sb__footer section_padding">
        <div className="sb__footer-links">
          <div className="sb__footer-links_div">
            <h4>GG-HWB</h4>
            <p>Golden Girls Health &amp;Well-Being (GG-HWB) Sports Club has been
              formed to champion women’s participation in sports in the country and
              beyond.</p>
            <div className="socialMedia">
              <a href="/home">
                <FacebookIcon
                  className="socialMediaImg"
                />
              </a>
              <a href="/home">
                <XIcon
                  className="socialMediaImg"
                />
              </a>
              <a href="/home">
                <InstagramIcon
                  className="socialMediaImg"
                />
              </a>
              <a href="/home">
                <YouTubeIcon
                  className="socialMediaImg"
                />
              </a>
              <a href="/home">
                <LinkedInIcon
                  className="socialMediaImg"
                />
              </a>
            </div>

          </div>
          <div className="sb__footer-links_div">
            <h4>Quick Links</h4>
            <a href="./home" id="link">
              <p>Home</p>
            </a>
            <a href="./blog" id="link">
              <p>Blog</p>
            </a>
            <a href="./about" id="link">
              <p>About</p>
            </a>
            <a href="./contact" id="link">
              <p>Contact Us</p>
            </a>
            <a href="./register" id="link">
              <p>Register</p>
            </a>
            <a href="/home#FAQ" id="link">
              <p>FAQ</p>
            </a>
          </div>
          <div className="sb__footer-links_div">
            <h4>Resources</h4>
            <a href="./media" id="link">
              <p>Pictorials</p>
            </a>
            <a href="./media" id="link">
              <p>Video Gallery</p>
            </a>
            <a href="./media" id="link">
              <p>Reports</p>
            </a>
          </div>
          <div className="sb__footer-links_div">
            <h4>Our Partners</h4>
            <a href="./contact">
              <p>Partner With GG-M</p>
            </a>
          </div>
          <div className="sb__footer-links_div">
            <h4>Reach-Out</h4>
            <div>
              <PlaceIcon />
              <p>Kuwinda Road Nairobi, Kenya</p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }} className="footerEmailStuff">
              <EmailIcon />
              <a href="mailto:infor@goldengirlshealthandwellbeing.org">info@goldengirlshealthandwellbeing.org</a>
              {/* <a href="mailto:goldengirlshealthandwellbeing@gmail.com">goldengirlshealthandwellbeing@gmail.com</a> */}
            </div>
          </div>
        </div>
      </div>
      <hr></hr>
      <div className="sb__footer-below">
        <div className="sb__footer-copyright">
          <p>
            Copyright &#169; {new Date().getFullYear()} Golden Girls Health & Well-Being. All rights reserved.
          </p>
        </div>
        <div className="sb__footer-below_links">
          <a href="/termsofuse">
            <div>
              <p>Terms & Conditions</p>
            </div>
          </a>
          <a href="/privacy">
            <div>
              <p>Privacy Policy</p>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
